import { render, staticRenderFns } from "./InformativeSidebar.vue?vue&type=template&id=1fe2b4cd&"
import script from "./InformativeSidebar.vue?vue&type=script&lang=js&"
export * from "./InformativeSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports